//4-up Cards
.card__wrapper {
	.four-up-cards & {
		overflow: hidden;
	}
}